<section
  class="relative h-full overflow-x-hidden overflow-y-auto pr-0.5 [-webkit-overflow-scrolling:touch]"
>
  <div
    class="custom-icon close absolute top-0 right-0 !m-5 !w-4 cursor-pointer !pt-4 !leading-4 md:!w-6 md:!pt-6 md:!leading-6"
    (click)="closeDialog()"
  ></div>
  <section class="p-6">
    <h1 class="text-xl md:text-3xl">Contact {{ title }}</h1>

    <div class="flex">
      <div class="mx-auto mt-5 flex">
        @if (contact) {
          @if (browserSize !== 'small') {
            <div class="custom-icon profile !mt-2.5 !mr-5 !w-8 !p-8"></div>
          }

          <div class="text-lg">
            @if (contact.Name) {
              <div class="text-3xl font-normal">{{ contact.Name }}</div>
            }
            @if (contact.Title) {
              <div class="mb-5 text-gray-600">{{ contact.Title }}</div>
            }
            @if (contact.Email) {
              <div class="flex items-center text-gray-600">
                <div class="custom-icon email_dark !mr-5">email icon</div>
                <a href="mailto:{{ contact.Email }}">{{ contact.Email }}</a>
              </div>
            }
            @if (contact.Phone) {
              <div class="flex items-center text-gray-600">
                <div class="custom-icon phone_dark !mr-5">phone icon</div>
                <a href="tel:{{ contact.Phone }}">{{ contact.Phone }}</a>
              </div>
            }
          </div>
        } @else if (errorMessage) {
          <div class="text-lg">Contact information is not available</div>
        }
      </div>
    </div>
  </section>
</section>
